import { useMarketplaceIdentity } from "@hooks/useMarketplaceIdentity";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { getReceivedMarketplaceOrders, marketplaceOrdersQueryKey } from "../api";
import { isLocallyDismissedFromDashboard } from "../dashboardDismissals";
import { isVisibleInOrderDashboard } from "../types";
import { useEnrichOrdersWithProductNames } from "./useEnrichOrdersWithProductNames";

export function useQueryReceivedOrders({ enabled = true } = {}) {
  const { sub, isAuthenticated } = useMarketplaceIdentity();

  const { data, isLoading, isError, error, isSuccess } = useQuery({
    queryKey: marketplaceOrdersQueryKey.received(sub),
    queryFn: ({ signal }) => getReceivedMarketplaceOrders({ signal }),
    enabled: enabled && isAuthenticated,
    staleTime: 0,
    retry: 1,
  });

  const enrichedOrders = useEnrichOrdersWithProductNames(data?.orders ?? []);
  const orders = useMemo(
    () =>
      enrichedOrders.filter(
        (order) =>
          isVisibleInOrderDashboard(order, "provider") &&
          !isLocallyDismissedFromDashboard(sub, "provider", order.id)
      ),
    [enrichedOrders, sub]
  );

  return {
    data: orders,
    total: data?.total ?? 0,
    isLoading,
    isError,
    error,
    isSuccess,
  };
}
